import { useEffect, useState } from 'react';
import english from '../../data/askExamples/en.json';

const POOL_SIZE = english.pool.length;
const SHOW = 4;
const SEEN_KEY = 'nowtarot_ask_seen';
const VISIT_KEY = 'nowtarot_ask_visit';
const PICK_KEY = 'nowtarot_ask_pick';

const LOADERS = {
  es: () => import('../../data/askExamples/es.json'),
  hi: () => import('../../data/askExamples/hi.json'),
  zh: () => import('../../data/askExamples/zh.json'),
  ar: () => import('../../data/askExamples/ar.json'),
  fr: () => import('../../data/askExamples/fr.json'),
  pt: () => import('../../data/askExamples/pt.json'),
  de: () => import('../../data/askExamples/de.json'),
  ja: () => import('../../data/askExamples/ja.json'),
  ko: () => import('../../data/askExamples/ko.json'),
  it: () => import('../../data/askExamples/it.json'),
  tr: () => import('../../data/askExamples/tr.json'),
  id: () => import('../../data/askExamples/id.json'),
  pl: () => import('../../data/askExamples/pl.json'),
  vi: () => import('../../data/askExamples/vi.json'),
  th: () => import('../../data/askExamples/th.json'),
  nl: () => import('../../data/askExamples/nl.json'),
  ru: () => import('../../data/askExamples/ru.json'),
  fil: () => import('../../data/askExamples/fil.json'),
  uk: () => import('../../data/askExamples/uk.json'),
  ro: () => import('../../data/askExamples/ro.json'),
  sv: () => import('../../data/askExamples/sv.json'),
  cs: () => import('../../data/askExamples/cs.json'),
  el: () => import('../../data/askExamples/el.json'),
  hu: () => import('../../data/askExamples/hu.json'),
};

// The first session on this browser keeps the static chips. A later session rotates.
function visitKind() {
  try {
    let visit = sessionStorage.getItem(VISIT_KEY);
    if (!visit) {
      visit = localStorage.getItem(SEEN_KEY) ? 'return' : 'first';
      sessionStorage.setItem(VISIT_KEY, visit);
      if (visit === 'first') localStorage.setItem(SEEN_KEY, '1');
    }
    return visit;
  } catch {
    return 'first';
  }
}

function pickIndices() {
  try {
    const saved = JSON.parse(sessionStorage.getItem(PICK_KEY) || 'null');
    if (
      Array.isArray(saved)
      && saved.length === SHOW
      && new Set(saved).size === SHOW
      && saved.every((index) => Number.isInteger(index) && index >= 0 && index < POOL_SIZE)
    ) {
      return saved;
    }
  } catch {
    // A fresh pick replaces an unreadable one.
  }
  const order = Array.from({ length: POOL_SIZE }, (_, index) => index);
  for (let i = order.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [order[i], order[j]] = [order[j], order[i]];
  }
  const pick = order.slice(0, SHOW);
  try {
    sessionStorage.setItem(PICK_KEY, JSON.stringify(pick));
  } catch {
    // private mode
  }
  return pick;
}

function fromPool(pool, indices) {
  if (!Array.isArray(pool) || pool.length !== POOL_SIZE) return null;
  return indices.map((index) => pool[index]);
}

export function useAskExamples(lang, defaults) {
  const [examples, setExamples] = useState(defaults || []);

  useEffect(() => {
    setExamples(defaults || []);
    if (!lang || navigator.userAgent === 'ReactSnap') return undefined;
    if (visitKind() !== 'return') return undefined;
    let live = true;
    const indices = pickIndices();
    const apply = (pool) => {
      const next = fromPool(pool, indices);
      if (live && next) setExamples(next);
    };
    if (lang === 'en') {
      apply(english.pool);
      return () => {
        live = false;
      };
    }
    const loader = LOADERS[lang];
    if (!loader) return () => {
      live = false;
    };
    loader()
      .then((mod) => apply((mod.default || mod).pool))
      .catch(() => {});
    return () => {
      live = false;
    };
  }, [lang, defaults]);

  return examples;
}
